export default __webpack_public_path__ + "static/media/burglary-filled.568cbdbf.svg";